interface DeliveryDay {
    label: string;
    date: string;
} // ISO YYYY-MM-DD

export function getDeliveryDays(baseDate?: Date): DeliveryDay[] {
    const days: DeliveryDay[] = [];
    const now = baseDate ? new Date(baseDate) : new Date();

    // --- utils ---
    const cloneDate = (d: Date) => new Date(d.getTime());
    const addDays = (d: Date, n: number) => {
        const c = cloneDate(d);
        c.setDate(c.getDate() + n);
        return c;
    };
    const normalizeToDay = (d: Date) => {
        const c = cloneDate(d);
        c.setHours(0, 0, 0, 0);
        return c;
    };

    const monthNames: string[] = [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień",
    ];

    const holidays = new Set<string>([
        "01-01",
        "01-06",
        "05-01",
        "05-03",
        "08-15",
        "11-01",
        "11-11",
        "12-25",
        "12-26",
    ]);

    const mmdd = (d: Date) =>
        `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    const isHoliday = (d: Date) => holidays.has(mmdd(d));

    const isWeekend = (d: Date) => {
        const day = d.getDay();
        return day === 0 || day === 6;
    };

    const isWorkday = (d: Date) => !isWeekend(d) && !isHoliday(d);

    const getNextWorkday = (from: Date) => {
        let d = addDays(from, 1);

        d = normalizeToDay(d);
        while (!isWorkday(d)) {
            d = addDays(d, 1);
        }
        return d;
    };

    const nowNormalized = cloneDate(now);
    const hour = nowNormalized.getHours();

    let startDate: Date;

    if (isWorkday(now)) {
        if (hour < 12) {
            startDate = getNextWorkday(now);
        } else {
            const tomorrow = addDays(now, 1);

            const firstWorkday = getNextWorkday(now);

            if (isWorkday(tomorrow)) {
                startDate = getNextWorkday(firstWorkday);
            } else {
                startDate = firstWorkday;
            }
        }
    } else {
        startDate = getNextWorkday(now);
    }

    let cursor = normalizeToDay(startDate);
    while (days.length < 5) {
        if (isWorkday(cursor)) {
            const day = cursor.getDate();
            const month = monthNames[cursor.getMonth()];
            const year = cursor.getFullYear();
            const iso = `${year}-${String(cursor.getMonth() + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            days.push({ label: `${day} ${month}`, date: iso });
        }
        cursor = addDays(cursor, 1);
    }

    return days;
}
